const urlPrefixForCLs = process.env.REACT_APP_URL_PREFIX;
export const masterDataConfig = {
  t_7a: [
    {
      key: "7a",
      url: `${urlPrefixForCLs}get_station_filters_cls`,
      options: {
        divisions: {
          option: [{ ZONE: "zone", DIVISION: "dvsn" }],
          uniqueKey: "dvsn",
        },
        stations: {
          option: [
            {
              ZONE: "zone",
              DIVISION: "dvsn",
              STATION_CODE: "station_code",
              STATION_NAME: "station_name",
            },
          ],
          uniqueKey: "station_code",
        },
      },
    },
  ],
};
